export default {
    ENTER_EMAIL: 'Unesite vašu email adresu',
    ENTER_PASSWORD: 'Unesite vašu lozinku',
    LABEL_EMAIL: 'Email',
    LABEL_PASSWORD: 'Lozinka',
    TITLE: 'Prijavi se',
    SUB_TITLE: 'Unesite email i lozinku da biste se prijavili',
    PERSIST_AUTH: 'Ostavi me prijavljenog',
    FORGOT_PASSWORD: 'Zaboravili ste lozinku?',
    LOGIN: 'Prijavi se',
    LOGIN_WITH: 'Ili nastavi sa',
    SIGN_IN_PROVIDER: 'Prijavi se sa',
    AUTH_ERROR: 'Backend error',
};
